var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272 68"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 34,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 34,
    r: 34
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjcyIiBoZWlnaHQ9IjY4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBjeD0iMzQiIGN5PSIzNCIgcj0iMzQiLz48Y2lyY2xlIGN4PSIxMzYiIGN5PSIzNCIgcj0iMzQiLz48Y2lyY2xlIGN4PSIyMzgiIGN5PSIzNCIgcj0iMzQiLz48L2c+PC9zdmc+";
export { SvgEllipsis as ReactComponent };